// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9d357b04","952":"2e82dafa"}[chunkId] + ".chunk.js";
};